import React, { useEffect, useMemo, useState, useRef } from "react";
import Banner from "../Components/Banner";
import LatestPosts from "../Components/LatestPosts";
import ScrollAnimation from "react-animate-on-scroll";

// Import our components
import {
    BuilderSelector,
    BuilderDetailsCard,
    IntroSection,
    DisplayVillageMap,
    ContactInfo,
} from "../Components/DisplayHomes";

// Import builder data separately to ensure proper import
import buildersData from "../Components/DisplayHomes/BuilderData";

const DisplayHomes = () => {
    // State to track which builder is selected
    const [selectedBuilder, setSelectedBuilder] = useState("gjgardner");

    // Create a ref for the builder section
    const builderSectionRef = useRef(null);

    // Get the currently selected builder data
    const selectedBuilderData = buildersData[selectedBuilder];
    const builderHomes = selectedBuilderData?.houses || [];

    const queryBuilder = useMemo(() => {
        try {
            const params = new URLSearchParams(window.location.search);
            const b = params.get('builder');
            return b && buildersData[b] ? b : null;
        } catch (e) {
            return null;
        }
    }, []);

    useEffect(() => {
        if (queryBuilder) {
            setSelectedBuilder(queryBuilder);
            if (builderSectionRef.current) {
                builderSectionRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [queryBuilder]);

    // Function to handle logo click
    const handleLogoClick = (builderId) => {
        setSelectedBuilder(builderId);

        // Scroll to the builder section with smooth behavior
        if (builderSectionRef.current) {
            builderSectionRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }
    };

    return (
        <>
            {/* Banner */}
            <Banner
                title={"Display Village Now Open"}
                bgImage="bg-display-home-banner"
            />
            {/* Banner */}

            {/* Content */}
            <section className="px-6 sm:px-10 xl:px-59 pt-8 sm:pt-10 lg:pt-14 2xl:pt-20 pb-8 sm:pb-16 lg:pb-16">
                <IntroSection />
            </section>

            {/* Builder Logos - Interactive Buttons */}
            <section id="builder-section" ref={builderSectionRef}>
                <BuilderSelector
                    builders={buildersData}
                    selectedBuilder={selectedBuilder}
                    onBuilderSelect={handleLogoClick}
                />

                {/* Builder Content Section - Fixed Height Container */}
                {/* Home Selection Tabs - Show only if builder has multiple homes */}
                {/* <div className={`${cardContainer} bg-lightGableGreen`}>
                    <div className={fixedHeightContainer}>
                        {builderHomes.length > 1 && (
                            <div className="flex mb-6 border-b">
                                {builderHomes.map((home, index) => (
                                    <button
                                        key={home.id || index}
                                        onClick={() => handleHomeSelect(index)}
                                        className={`px-4 py-2 mr-2 ${
                                            selectedHomeIndex[selectedBuilder] === index
                                                ? 'border-b-2 border-honeysuckle font-semibold'
                                                : 'text-gray-600'
                                        }`}
                                    >
                                        {home.homeName}
                                    </button>
                                ))}
                            </div>
                        )}

                        <BuilderDetailsCard
                            builder={currentHome}
                            currentImageIndex={currentImageIndex[selectedBuilder]}
                            onPrevImage={handlePrevImage}
                            onNextImage={handleNextImage}
                        />
                    </div>
                </div> */}

                <div className={`${cardContainer} bg-lightGableGreen`}>
                    <div className={fixedHeightContainer}>
                        {builderHomes.map((home, index) => (
                            <React.Fragment key={home.id || index}>
                                <BuilderDetailsCard
                                    builder={home}
                                    isLast={index === builderHomes.length - 1}
                                />
                                {index < builderHomes.length - 1 && (
                                    <hr className="my-6 border-t border-gray-300" />
                                )}
                            </React.Fragment>
                        ))}
                    </div>
                </div>
            </section>

            {/* Display contact details once per builder at the base */}
            {selectedBuilderData?.contactDetails && (
                <section className="px-6 sm:px-10 xl:px-59 pt-8 sm:pt-10 lg:pt-14 2xl:pt-20 pb-8 sm:pb-16 lg:pb-16 bg-parchment">
                    {/* <h3 className="text-xl font-semibold text-gableGreen mb-4">
                                        Contact{" "}
                                        {selectedBuilderData.houses[0]?.name ||
                                            "Builder"}
                                    </h3> */}
                    <ContactInfo
                        contactDetails={selectedBuilderData.contactDetails}
                    />
                </section>
            )}

            {/* Australia's Best Builders Section */}
            {/* <section className='bg-honeysuckle-light px-6 sm:px-10 xl:px-59 pt-12 sm:pt-16 lg:pt-20 pb-12 sm:pb-20 lg:pb-16'>
                <ScrollAnimation animateIn="fadeIn" animateOnce={true}>
                    <CallToAction />
                </ScrollAnimation>
            </section> */}
            {/* Content */}

            {/* Display Village Map Section */}
            <section>
                <ScrollAnimation animateIn="fadeIn" animateOnce={true}>
                    <DisplayVillageMap />
                </ScrollAnimation>
            </section>

            {/* Latest Posts with improved styling */}
            <LatestPosts />
        </>
    );
};

const cardContainer = "p-8 sm:p-10 lg:p-16 xl:p-20 bg-white w-full";
const fixedHeightContainer =
    "transition-all duration-300 ease-in-out";

export default DisplayHomes;
